"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.wishlistQueries = exports.wishlistQueryKeys = void 0;
const wishlist_api_1 = require("./wishlist.api");
exports.wishlistQueryKeys = {
    all: () => ['wishlist'],
    WishlistProducts: (params) => [...exports.wishlistQueryKeys.all(), 'WishlistGetProducts', params],
};
const wishlistQueries = (apiOptions) => ({
    getWishlistProducts: (params, options = {}) => (Object.assign(Object.assign({}, options), { queryKey: exports.wishlistQueryKeys.WishlistProducts(params), queryFn: () => (0, wishlist_api_1.getWishlistProducts)(apiOptions, params) })),
});
exports.wishlistQueries = wishlistQueries;
//# sourceMappingURL=wishlist.queries.js.map